import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCurveEasing32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconCurveEasing32"
            aria-hidden="true"
            {...props}
        >
            <g fill="currentColor">
                <path d="M22 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m0 4a1 1 0 1 0-2 0 3 3 0 0 1-3 3h-8a1 1 0 1 0 0 2h8a5 5 0 0 0 5-5" />
                <path
                    fillRule="evenodd"
                    d="M5 9a4 4 0 0 1 4-4h14a4 4 0 0 1 4 4v14a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4zm4-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2"
                    clipRule="evenodd"
                />
            </g>
        </svg>
    );
}
export default memo(IconCurveEasing32);
